export default __webpack_public_path__ + "static/media/copy.6966e0fb.svg";